// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sg-1";
export var stateContainer = "_sg-0";